module.exports = __webpack_public_path__ + "img/19.7beca2e9.jpg";